var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeenyiconsWalletAltOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_15637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5715 10.3579V5.3579C20.5715 4.97902 20.421 4.61565 20.1531 4.34774C19.8852 4.07983 19.5218 3.92932 19.1429 3.92932H3.42858C3.0497 3.92932 2.68633 4.07983 2.41842 4.34774C2.15051 4.61565 2 4.97902 2 5.3579V19.6437C2 20.0226 2.15051 20.3859 2.41842 20.6538C2.68633 20.9217 3.0497 21.0723 3.42858 21.0723H19.1429C19.5218 21.0723 19.8852 20.9217 20.1531 20.6538C20.421 20.3859 20.5715 20.0226 20.5715 19.6437V14.6437M21.9001 9.64363H14.8572C14.0994 9.64363 13.3727 9.94465 12.8369 10.4805C12.3011 11.0163 12 11.743 12 12.5008C12 13.2586 12.3011 13.9853 12.8369 14.5211C13.3727 15.0569 14.0994 15.3579 14.8572 15.3579H21.9001C21.9266 15.3579 21.952 15.3474 21.9708 15.3287C21.9896 15.3099 22.0001 15.2845 22.0001 15.2579V9.74363C22.0001 9.71711 21.9896 9.69168 21.9708 9.67292C21.952 9.65417 21.9266 9.64363 21.9001 9.64363Z",
    stroke: "#0DEB9B",
    strokeWidth: 1.42858
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    filter: "url(#filter0_f_970_15637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5715 10.3579V5.3579C20.5715 4.97902 20.421 4.61565 20.1531 4.34774C19.8852 4.07983 19.5218 3.92932 19.1429 3.92932H3.42858C3.0497 3.92932 2.68633 4.07983 2.41842 4.34774C2.15051 4.61565 2 4.97902 2 5.3579V19.6437C2 20.0226 2.15051 20.3859 2.41842 20.6538C2.68633 20.9217 3.0497 21.0723 3.42858 21.0723H19.1429C19.5218 21.0723 19.8852 20.9217 20.1531 20.6538C20.421 20.3859 20.5715 20.0226 20.5715 19.6437V14.6437M21.9001 9.64363H14.8572C14.0994 9.64363 13.3727 9.94465 12.8369 10.4805C12.3011 11.0163 12 11.743 12 12.5008C12 13.2586 12.3011 13.9853 12.8369 14.5211C13.3727 15.0569 14.0994 15.3579 14.8572 15.3579H21.9001C21.9266 15.3579 21.952 15.3474 21.9708 15.3287C21.9896 15.3099 22.0001 15.2845 22.0001 15.2579V9.74363C22.0001 9.71711 21.9896 9.69168 21.9708 9.67292C21.952 9.65417 21.9266 9.64363 21.9001 9.64363Z",
    stroke: "#0DEB9B",
    strokeWidth: 1.42858
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_970_15637",
    x: -1.50387,
    y: 0.425088,
    width: 27.0087,
    height: 24.1514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.395,
    result: "effect1_foregroundBlur_970_15637"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_15637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsWalletAltOutline);
export default __webpack_public_path__ + "static/media/teenyicons_wallet-alt-outline.091ec36f0d425a63d530fc65d9b082c5.svg";
export { ForwardRef as ReactComponent };